import { useState, useEffect } from 'react';

export const useDarkMode = () => {
  const [dark, setDark] = useState(() => document.querySelector('.app.dark') !== null);
  useEffect(() => {
    const observer = new MutationObserver(() => {
      setDark(document.querySelector('.app.dark') !== null);
    });
    const appEl = document.querySelector('.app');
    if (appEl) observer.observe(appEl, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);
  return dark;
};

export const useTheme = () => {
  const dark = useDarkMode();
  return {
    dark,
    bg: dark ? '#16213e' : '#fff',
    bgAlt: dark ? '#1e293b' : '#f8fafc',
    cardBorder: dark ? '#2d3748' : '#e2e8f0',
    heading: dark ? '#e2e8f0' : '#0f172a',
    text: dark ? '#cbd5e1' : '#334155',
    textMuted: dark ? '#94a3b8' : '#94a3b8',
    textSecondary: dark ? '#94a3b8' : '#64748b',
    tableBg: dark ? '#16213e' : '#fff',
    tableHeaderBg: dark ? '#1e293b' : '#f8fafc',
    tableHeaderColor: dark ? '#94a3b8' : '#64748b',
    tableBorder: dark ? '#2d3748' : '#e2e8f0',
    tableRowHover: dark ? 'rgba(255,255,255,0.03)' : '#f8fafc',
    inputBg: dark ? '#1e293b' : '#fff',
    inputBorder: dark ? '#2d3748' : '#e2e8f0',
    inputColor: dark ? '#e2e8f0' : '#1e293b',
    modalBg: dark ? '#16213e' : '#fff',
    totalsBg: dark ? '#1e293b' : '#f8fafc',
  };
};
